var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHarekatAval(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-2281.007 -1619.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-2",
    d: "M2638.214,1850.106a7.474,7.474,0,0,0-3.775.364c-1.562.574-3.08,1.272-4.6,1.958-1.726.78-3.43,1.607-5.145,2.413-.147.07-.3.133-.518.231v-1.818c.112-.061.251-.146.4-.214,2.543-1.2,5.072-2.428,7.637-3.576,1.055-.472,2.191-.764,3.254-1.127-1.275-.731-2.639-1.2-4.164-.132v-1.868a3.3,3.3,0,0,1,2.9-.431,13.551,13.551,0,0,1,1.892.83c.715.351,1.412.739,2.117,1.11Z",
    transform: "translate(-310.729 -202.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-2",
    d: "M2511.5,1804.232v1.708l3.812-1.785-1.456-1.24v-2.565l7.568-3.56v1.856l-6.279,2.963c.456.454.87.861,1.279,1.275a1.664,1.664,0,0,1-.515,2.864q-1.938.916-3.881,1.822c-.161.075-.326.14-.588.251v-1.712c-.281.112-.457.172-.625.25-2.263,1.055-4.523,2.119-6.79,3.164a3.513,3.513,0,0,1-2.279.341,1.685,1.685,0,0,1-1.3-1.134,2.913,2.913,0,0,1,1.47-3.766c.409-.175.808-.372,1.268-.584v1.832a9.5,9.5,0,0,0-1.1.567,1.777,1.777,0,0,0-.615.671.642.642,0,0,0,.583.9,2.555,2.555,0,0,0,1.036-.223c2.623-1.209,5.235-2.442,7.851-3.667C2511.1,1804.386,2511.261,1804.328,2511.5,1804.232Z",
    transform: "translate(-198.016 -158.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-2",
    d: "M2460.024,1637.132c-.492-1.155-1.043-2.289-1.445-3.474a2.506,2.506,0,0,1,.112-1.5,45.123,45.123,0,0,1,3.9-8.271c.928-1.561,1.861-1.538,2.827.015a27.031,27.031,0,0,1,2.945,7.3,58.069,58.069,0,0,1,1.544,8.33.309.309,0,0,1-.08.26c-.039-.139-.079-.277-.117-.416a64.245,64.245,0,0,0-3.248-9.512,16.212,16.212,0,0,0-1.3-2.317c-.519-.779-1.112-.818-1.814-.192a4.722,4.722,0,0,0-.745.842,23.053,23.053,0,0,0-2.567,5.056,5.356,5.356,0,0,0-.021,3.157c.052.225.09.453.135.679Z",
    transform: "translate(-160.051 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-2",
    d: "M2288.9,1802.918v1.8c-.383.187-.771.379-1.162.568-1.057.51-2.115,1.017-3.17,1.532a2.3,2.3,0,0,0-.535.33.784.784,0,0,0-.258.932.712.712,0,0,0,.808.436,1.661,1.661,0,0,0,.567-.127q2.576-1.2,5.142-2.43a2.025,2.025,0,0,0,.222-.149v-8.172l1.619-.7c.02.23.045.385.045.54,0,2.74,0,5.481,0,8.221a1.75,1.75,0,0,1-1.125,1.771c-1.58.7-3.125,1.489-4.711,2.18a5.162,5.162,0,0,1-1.737.406,1.814,1.814,0,0,1-2.01-1.658,2.847,2.847,0,0,1,1.7-3.323q2.058-.98,4.117-1.958C2288.546,1803.053,2288.683,1803,2288.9,1802.918Z",
    transform: "translate(0 -158.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-2",
    d: "M2396.48,1847.231v-1.773l4.9-2.309v-.555c-.2.081-.353.133-.5.2-.683.314-1.355.653-2.047.944a1.18,1.18,0,0,1-1.769-1.143,6.262,6.262,0,0,1,.232-1.73,1.923,1.923,0,0,1,2.352-1.452,4.145,4.145,0,0,1,2.981,3.8,1.918,1.918,0,0,1-1.049,1.683c-1.629.807-3.283,1.562-4.928,2.335C2396.618,1847.245,2396.569,1847.231,2396.48,1847.231Zm1.9-5.115,1.773-.807a1.12,1.12,0,0,0-1.28-.291A.936.936,0,0,0,2398.38,1842.116Z",
    transform: "translate(-103.638 -197.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-2",
    d: "M2521.9,1953.857c.155.761.269,1.535.476,2.281.277,1,.6,1.985.96,2.955a3.4,3.4,0,0,0,.684,1.049.863.863,0,0,0,1.529-.12,4.991,4.991,0,0,0,.687-1.46c.49-2.106.92-4.225,1.361-6.342a8.344,8.344,0,0,1,.242-1.151c-.017.324-.03.649-.052.972a40.957,40.957,0,0,1-1.19,8.467,12.891,12.891,0,0,1-1.036,2.384,1.313,1.313,0,0,1-1.413.685,1.291,1.291,0,0,1-1.167-.992,24.557,24.557,0,0,1-.591-3c-.227-1.819-.377-3.647-.557-5.471-.008-.083,0-.168,0-.252Z",
    transform: "translate(-217.645 -298.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-2",
    d: "M2478.9,1805.755l-1.609.7v-8.844l1.609-.716Z",
    transform: "translate(-177.138 -158.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-2",
    d: "M2553.377,1845.524v1.858l-3.5,1.653v-1.86Z",
    transform: "translate(-243.149 -202.632)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarekatAval);
export default __webpack_public_path__ + "static/media/harekatAval.1862e027f56ead74be366ba669840175.svg";
export { ForwardRef as ReactComponent };